import React from "react";
import {
  IconButton,
  makeStyles,
  Popover,
  Tooltip,
  Typography,
  ListItem,
  ListItemIcon,
  List,
} from "@material-ui/core";
import { isEmpty, isNil } from "lodash";
import { useTranslation } from "react-i18next";

import { useMenuAnchor } from "../../../../core/hooks/useMenuAnchor";
import { useAccessesStore } from "../../../../core/stores/AccessesStore";
import { getLocaleText } from "../../../../util/UtilTraduction";
import { useTheme } from "@material-ui/core/styles";
import { HighlightNewFeature } from "../highlight/HighlightNewFeature";

const useStyles = makeStyles(() => ({
  mainButton: {
    marginBlock: 6,
    padding: 0,
  },
  listItemIcon: {
    minWidth: "auto",
    marginRight: 10,
  },
  itemsTitle: {
    padding: "20px 15px 0px 20px",
    fontWeight: "bold",
  }, 
  listItemText: {
    marginRight: 10,
  }, 
  svLogoIcon: {
    width: 30,
  },
}));

export default function SmartVisionButton({ handleProcessClick, isMobile }) {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const [anchorEl, openMenuAnchor, closeMenuAnchor] = useMenuAnchor();
  const { smartVisionList } = useAccessesStore((state) => ({
    smartVisionList: state.smartVisionList,
  }));

  const open = Boolean(anchorEl);
  const id = open ? "qsdashboards_popover" : undefined;
  const theme = useTheme();

  function handleItemClick(item) {
    closeMenuAnchor();
    handleProcessClick({
      name: item.name,
      propText: item.propText,
      route: item.route,
    });
  }

  if (
    isNil(smartVisionList) ||
    (!isNil(smartVisionList) && isEmpty(smartVisionList))
  ) {
    return null;
  }

  return (
    <HighlightNewFeature endDate={"2025-06-15"}>
        <Tooltip title={t("DISPLAY_NAME_SV")} placement="right">
      <IconButton className={classes.mainButton} onClick={openMenuAnchor}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/icons/menu/SmartVision_${theme.palette.type}.png`}
          alt="smart-vision-logo"
          className={classes.svLogoIcon}
        />
      </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={closeMenuAnchor}
        anchorOrigin={{
          vertical: "center",
          horizontal: isMobile ? "left" : "right",
        }}
        transformOrigin={{
          vertical: isMobile ? "'top" : "center",
          horizontal: isMobile ? "right" : "left",
        }}
      >
        <div>
          <Typography variant="h6" className={classes.itemsTitle}>
            {t("MY_BOARDS")}
          </Typography>
          <List>
            {smartVisionList
              .filter((x) => !isNil(x))
              .map((x) => {
                return (
                  <ListItem
                    button
                    key={x?.route}
                    onClick={() => handleItemClick(x)}
                  >
                    <ListItemIcon>
                      <Typography variant="h6" className={classes.listItemText}>
                        {getLocaleText(x?.propText, i18n)}
                      </Typography>
                    </ListItemIcon>
                  </ListItem>
                );
              })}
          </List>
        </div>
      </Popover>
    </HighlightNewFeature>
  );
}
